import request from "@/yintai/utils/request";

export function fetchPicture(data) {
  return request({
    url: "/picture/out/list",
    method: "post",
    data,
  });
}
